import { z } from 'zod';

export const skillsBannerStatusSchema = z.enum(['display', 'hidden']);

export const skillsBannersSchema = z.object({
    addSkills: skillsBannerStatusSchema.optional(),
    addSkillsProficiency: skillsBannerStatusSchema.optional(),
});

export type SkillsBanners = z.infer<typeof skillsBannersSchema>;
